module.exports = __webpack_public_path__ + "img/ai_msg_icon.b18169fa.png";